// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ohntdpbcubtyghbeevro.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9obnRkcGJjdWJ0eWdoYmVldnJvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc2MDc0NDMsImV4cCI6MjA3MzE4MzQ0M30.2Vpvo_cmCYecJfcuSJ910wNPiSKqCbR80Qe26L639GQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});